module.exports = __webpack_public_path__ + "img/icon-VB-flat.c5cb1665.png";